import { useQuery } from '@tanstack/react-query';

import { ApiKey } from 'src/features/apiKeys/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';

type QueryFnType = typeof queryFn;

interface DTO {
    keyId: string;
    parkingId: string;
}
const queryFn = ({ keyId, parkingId }: DTO): Promise<ApiKey> => {
    return axios.get(`sp-core/${parkingId}/system/api-key/${keyId}`);
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) => {
    const parkingId = payload.parkingId;
    const keyId = payload.keyId;
    const RESOURCE = `sp-core/${parkingId}/system/api-key/${keyId}`;
    return useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });
};

export { useQueryHook as useGetApiKey };
